// extracted by mini-css-extract-plugin
export default {"Container":"NoUqQR4TQHWEw8DiCUiA","SettingsSwitches":"MefFGS6rrmKlFYGmpLhl"};